// extracted by mini-css-extract-plugin
export default {"tabSwitchContainer":"style_tabSwitchContainer__bXo0V","tabItem":"style_tabItem__lHTWF","tabIndicator":"style_tabIndicator__uHLbc"};